<template>
  <div>
    <head>
      <link rel="shortcut icon" href="assets/images/favicon.svg">
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
    </head>

    <body @contextmenu.prevent data-sidebar="dark">
      <div id="layout-wrapper">
        <NavigationBar />

        <div id="content" class="content-minimize">
          <div class="page-content">
            <div class="container-fluid">

              <!-- Page Title -->
              <div class="row">
                <div class="col-12">
                  <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h4 class="mb-sm-0 font-size-18">Ward Management</h4>
                    <div class="page-title-right">
                      <ol class="breadcrumb m-0">
                        <li class="breadcrumb-item"><a href="javascript:void(0);" @click="goTo('hospital-dashboard')">Hospital</a></li>
                        <li class="breadcrumb-item"><a href="javascript:void(0);" @click="goTo('ipd-dashboard')">IPD</a></li>
                        <li class="breadcrumb-item active">Ward Management</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tabs -->
              <div class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <ul class="nav nav-tabs nav-tabs-custom">
                        <li class="nav-item">
                          <a class="nav-link" :class="{ active: activeTab === 'wards' }" href="javascript:void(0);" @click="activeTab = 'wards'">
                            <i class="mdi mdi-hospital-building me-1"></i> Wards
                          </a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" :class="{ active: activeTab === 'beds' }" href="javascript:void(0);" @click="activeTab = 'beds'">
                            <i class="mdi mdi-bed me-1"></i> Beds
                          </a>
                        </li>
                      </ul>

                      <!-- Wards Tab -->
                      <div v-if="activeTab === 'wards'" class="pt-4">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <h5 class="mb-0">Wards</h5>
                          <button class="btn btn-primary" @click="openWardModal()">
                            <i class="mdi mdi-plus me-1"></i> Add Ward
                          </button>
                        </div>

                        <div v-if="loadingWards" class="text-center py-4">
                          <div class="spinner-border text-primary"></div>
                        </div>

                        <div v-else class="table-responsive">
                          <table class="table table-hover align-middle">
                            <thead class="table-light">
                              <tr>
                                <th>Ward Name</th>
                                <th>Type</th>
                                <th>Floor/Wing</th>
                                <th class="text-center">Total Beds</th>
                                <th class="text-center">Available</th>
                                <th class="text-center">Occupied</th>
                                <th class="text-end">Daily Rate</th>
                                <th>Status</th>
                                <th class="text-center">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="ward in wards" :key="ward.wardID">
                                <td>
                                  <strong>{{ ward.wardName }}</strong>
                                  <small v-if="ward.wardCode" class="text-muted d-block">{{ ward.wardCode }}</small>
                                </td>
                                <td><span class="badge" :class="getWardTypeBadge(ward.wardType)">{{ ward.wardType }}</span></td>
                                <td>{{ ward.floor || '-' }} {{ ward.wing ? '/ ' + ward.wing : '' }}</td>
                                <td class="text-center">{{ ward.totalBeds }}</td>
                                <td class="text-center text-success fw-medium">{{ ward.availableBeds || 0 }}</td>
                                <td class="text-center text-warning fw-medium">{{ ward.occupiedBeds || 0 }}</td>
                                <td class="text-end">KES {{ numberFormat(ward.chargePerDay || ward.dailyRate) }}</td>
                                <td>
                                  <span class="badge" :class="ward.status === 'Active' ? 'bg-success' : 'bg-secondary'">
                                    {{ ward.status }}
                                  </span>
                                </td>
                                <td class="text-center">
                                  <div class="btn-group btn-group-sm">
                                    <button class="btn btn-soft-info" @click="viewWardBeds(ward)" title="View Beds">
                                      <i class="mdi mdi-bed"></i>
                                    </button>
                                    <button class="btn btn-soft-warning" @click="openWardModal(ward)" title="Edit">
                                      <i class="mdi mdi-pencil"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                              <tr v-if="wards.length === 0">
                                <td colspan="9" class="text-center py-4 text-muted">
                                  <i class="mdi mdi-hospital-building font-size-48 d-block mb-2"></i>
                                  No wards found
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <!-- Beds Tab -->
                      <div v-if="activeTab === 'beds'" class="pt-4">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                          <div class="d-flex gap-2 align-items-center">
                            <h5 class="mb-0">Beds</h5>
                            <select class="form-select form-select-sm" v-model="filterWardID" @change="loadBeds" style="width: 200px;">
                              <option value="">All Wards</option>
                              <option v-for="ward in wards" :key="ward.wardID" :value="ward.wardID">{{ ward.wardName }}</option>
                            </select>
                          </div>
                          <button class="btn btn-primary" @click="openBedModal()">
                            <i class="mdi mdi-plus me-1"></i> Add Bed
                          </button>
                        </div>

                        <div v-if="loadingBeds" class="text-center py-4">
                          <div class="spinner-border text-primary"></div>
                        </div>

                        <div v-else class="table-responsive">
                          <table class="table table-hover align-middle">
                            <thead class="table-light">
                              <tr>
                                <th>Bed Number</th>
                                <th>Ward</th>
                                <th>Bed Type</th>
                                <th>Status</th>
                                <th>Current Patient</th>
                                <th class="text-center">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="bed in beds" :key="bed.bedID" :class="getBedRowClass(bed)">
                                <td><strong>{{ bed.bedNumber }}</strong></td>
                                <td>{{ bed.wardName }}</td>
                                <td><span class="badge bg-light text-dark">{{ bed.bedType }}</span></td>
                                <td>
                                  <span class="badge" :class="getBedStatusBadge(bed.bedStatus || bed.status)">{{ bed.bedStatus || bed.status }}</span>
                                </td>
                                <td>
                                  <span v-if="bed.currentPatientName">{{ bed.currentPatientName }}</span>
                                  <span v-else class="text-muted">-</span>
                                </td>
                                <td class="text-center">
                                  <div class="btn-group btn-group-sm">
                                    <button class="btn btn-soft-warning" @click="openBedModal(bed)" title="Edit">
                                      <i class="mdi mdi-pencil"></i>
                                    </button>
                                    <button v-if="bed.bedStatus === 'OCCUPIED' || bed.status === 'Occupied'" class="btn btn-soft-danger" @click="viewPatient(bed)" title="View Patient">
                                      <i class="mdi mdi-account"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                              <tr v-if="beds.length === 0">
                                <td colspan="6" class="text-center py-4 text-muted">
                                  <i class="mdi mdi-bed font-size-48 d-block mb-2"></i>
                                  No beds found
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <footer class="footer">
            <div class="container-fluid">
              <div class="row">
                <div class="col-sm-6"></div>
                <div class="col-sm-6">
                  <div class="text-sm-end d-sm-block">County Hospital Management System</div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>

      <!-- Ward Modal -->
      <div class="modal fade" id="wardModal" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <i class="mdi me-2" :class="isEditingWard ? 'mdi-pencil text-warning' : 'mdi-plus text-primary'"></i>
                {{ isEditingWard ? 'Edit Ward' : 'Add New Ward' }}
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label class="form-label">Ward Name <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="wardForm.wardName" placeholder="e.g., Male Medical Ward">
              </div>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Ward Code</label>
                  <input type="text" class="form-control" v-model="wardForm.wardCode" placeholder="e.g., MMW">
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Ward Type <span class="text-danger">*</span></label>
                  <select class="form-select" v-model="wardForm.wardType">
                    <option value="">Select Type</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Pediatric">Pediatric</option>
                    <option value="Maternity">Maternity</option>
                    <option value="ICU">ICU</option>
                    <option value="HDU">HDU</option>
                    <option value="Newborn">Newborn</option>
                    <option value="Isolation">Isolation</option>
                    <option value="General">General</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Floor</label>
                  <input type="text" class="form-control" v-model="wardForm.floor" placeholder="e.g., Ground Floor">
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Wing</label>
                  <input type="text" class="form-control" v-model="wardForm.wing" placeholder="e.g., East Wing">
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Total Beds</label>
                  <input type="number" class="form-control" v-model="wardForm.totalBeds" min="0">
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Daily Rate (KES) <span class="text-danger">*</span></label>
                  <input type="number" class="form-control" v-model="wardForm.dailyRate" min="0" placeholder="0">
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label">Nurse In Charge</label>
                <input type="text" class="form-control" v-model="wardForm.nurseInCharge" placeholder="Enter name">
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary" @click="saveWard" :disabled="!canSaveWard || savingWard">
                <span v-if="savingWard"><i class="mdi mdi-loading mdi-spin me-1"></i> Saving...</span>
                <span v-else><i class="mdi mdi-check me-1"></i> {{ isEditingWard ? 'Update' : 'Save' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Bed Modal -->
      <div class="modal fade" id="bedModal" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                <i class="mdi me-2" :class="isEditingBed ? 'mdi-pencil text-warning' : 'mdi-plus text-primary'"></i>
                {{ isEditingBed ? 'Edit Bed' : 'Add New Bed' }}
              </h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
              <div class="mb-3">
                <label class="form-label">Ward <span class="text-danger">*</span></label>
                <select class="form-select" v-model="bedForm.wardID" @change="setBedWardName">
                  <option value="">Select Ward</option>
                  <option v-for="ward in wards" :key="ward.wardID" :value="ward.wardID">{{ ward.wardName }}</option>
                </select>
              </div>
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">Bed Number <span class="text-danger">*</span></label>
                  <input type="text" class="form-control" v-model="bedForm.bedNumber" placeholder="e.g., B-101">
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">Bed Type</label>
                  <select class="form-select" v-model="bedForm.bedType">
                    <option value="Standard">Standard</option>
                    <option value="Electric">Electric</option>
                    <option value="ICU">ICU</option>
                    <option value="Cot">Cot</option>
                    <option value="Incubator">Incubator</option>
                  </select>
                </div>
              </div>
              <div class="mb-3" v-if="isEditingBed">
                <label class="form-label">Status</label>
                <select class="form-select" v-model="bedForm.status" :disabled="bedForm.status === 'Occupied'">
                  <option value="Available">Available</option>
                  <option value="Maintenance">Maintenance</option>
                  <option value="Reserved">Reserved</option>
                  <option value="Occupied" disabled>Occupied</option>
                </select>
                <small v-if="bedForm.status === 'Occupied'" class="text-muted">Cannot change status while bed is occupied</small>
              </div>
              <div class="mb-3">
                <label class="form-label">Notes</label>
                <textarea class="form-control" rows="2" v-model="bedForm.notes" placeholder="Optional notes..."></textarea>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary" @click="saveBed" :disabled="!canSaveBed || savingBed">
                <span v-if="savingBed"><i class="mdi mdi-loading mdi-spin me-1"></i> Saving...</span>
                <span v-else><i class="mdi mdi-check me-1"></i> {{ isEditingBed ? 'Update' : 'Save' }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Toast Notification -->
      <ToastNotification ref="toast" />
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import ToastNotification from "@/components/hospital/ToastNotification.vue";
import { execute, hospital } from "@/api";

export default {
  name: "WardManagement",
  components: { NavigationBar, ToastNotification },
  data() {
    return {
      activeTab: 'wards',
      loadingWards: false,
      loadingBeds: false,

      // Wards
      wards: [],
      isEditingWard: false,
      savingWard: false,
      wardForm: {
        wardID: '',
        wardName: '',
        wardCode: '',
        wardType: '',
        floor: '',
        wing: '',
        totalBeds: 0,
        dailyRate: '',
        nurseInCharge: ''
      },

      // Beds
      beds: [],
      filterWardID: '',
      isEditingBed: false,
      savingBed: false,
      bedForm: {
        bedID: '',
        wardID: '',
        wardName: '',
        bedNumber: '',
        bedType: 'Standard',
        status: 'Available',
        notes: ''
      },

      // Session
      facilityID: '',
      facilityName: '',
      sessionNames: '',
      sessionIdNo: ''
    };
  },
  computed: {
    canSaveWard() {
      return this.wardForm.wardName && this.wardForm.wardType && this.wardForm.dailyRate;
    },
    canSaveBed() {
      return this.bedForm.wardID && this.bedForm.bedNumber;
    }
  },
  methods: {
    goTo(route) {
      this.$router.push('/' + route);
    },

    numberFormat(num) {
      return Number(num || 0).toLocaleString();
    },

    getWardTypeBadge(type) {
      const badges = {
        'Male': 'bg-primary',
        'Female': 'bg-danger',
        'Pediatric': 'bg-success',
        'Maternity': 'bg-pink',
        'ICU': 'bg-dark',
        'HDU': 'bg-warning text-dark',
        'Newborn': 'bg-info',
        'Isolation': 'bg-secondary',
        'General': 'bg-light text-dark'
      };
      return badges[type] || 'bg-secondary';
    },

    getBedStatusBadge(status) {
      const s = (status || '').toUpperCase();
      if (s === 'AVAILABLE') return 'bg-success';
      if (s === 'OCCUPIED') return 'bg-danger';
      if (s === 'MAINTENANCE') return 'bg-warning text-dark';
      if (s === 'RESERVED') return 'bg-info';
      return 'bg-secondary';
    },

    getBedRowClass(bed) {
      const status = (bed.bedStatus || bed.status || '').toUpperCase();
      if (status === 'OCCUPIED') return 'table-danger';
      if (status === 'MAINTENANCE') return 'table-warning';
      if (status === 'RESERVED') return 'table-info';
      return '';
    },

    // Load Data
    loadWards() {
      this.loadingWards = true;
      const data = new FormData();
      data.append("function", "getWardOccupancy");
      data.append("facilityID", this.facilityID);

      execute(data, hospital)
        .then((res) => {
          this.loadingWards = false;
          if (res.data.success) {
            this.wards = res.data.data.wards || [];
          }
        })
        .catch((e) => {
          this.loadingWards = false;
          console.error(e);
        });
    },

    loadBeds() {
      this.loadingBeds = true;
      const data = new FormData();
      data.append("function", "getBeds");
      data.append("facilityID", this.facilityID);
      if (this.filterWardID) {
        data.append("wardID", this.filterWardID);
      }

      execute(data, hospital)
        .then((res) => {
          this.loadingBeds = false;
          if (res.data.success) {
            this.beds = res.data.data.beds || [];
          }
        })
        .catch((e) => {
          this.loadingBeds = false;
          console.error(e);
        });
    },

    viewWardBeds(ward) {
      this.activeTab = 'beds';
      this.filterWardID = ward.wardID;
      this.loadBeds();
    },

    // Ward Modal
    openWardModal(ward = null) {
      this.isEditingWard = !!ward;
      if (ward) {
        this.wardForm = { ...ward };
      } else {
        this.wardForm = {
          wardID: '',
          wardName: '',
          wardCode: '',
          wardType: '',
          floor: '',
          wing: '',
          totalBeds: 0,
          dailyRate: '',
          nurseInCharge: ''
        };
      }
      const modal = new bootstrap.Modal(document.getElementById('wardModal'));
      modal.show();
    },

    saveWard() {
      if (!this.canSaveWard) return;

      this.savingWard = true;
      const data = new FormData();
      data.append("function", this.isEditingWard ? "updateWard" : "addWard");
      data.append("facilityID", this.facilityID);
      data.append("facilityName", this.facilityName);
      
      if (this.isEditingWard) {
        data.append("wardID", this.wardForm.wardID);
      }
      
      data.append("wardName", this.wardForm.wardName);
      data.append("wardCode", this.wardForm.wardCode);
      data.append("wardType", this.wardForm.wardType);
      data.append("floor", this.wardForm.floor);
      data.append("wing", this.wardForm.wing);
      data.append("totalBeds", this.wardForm.totalBeds);
      data.append("dailyRate", this.wardForm.dailyRate);
      data.append("nurseInCharge", this.wardForm.nurseInCharge);
      data.append("sessionNames", this.sessionNames);
      data.append("sessionIdNo", this.sessionIdNo);

      execute(data, hospital)
        .then((res) => {
          this.savingWard = false;
          if (res.data.success) {
            this.$refs.toast.success(this.isEditingWard ? 'Ward updated successfully' : 'Ward added successfully');
            bootstrap.Modal.getInstance(document.getElementById('wardModal')).hide();
            this.loadWards();
          } else {
            this.$refs.toast.error(res.data.message || 'Failed to save ward');
          }
        })
        .catch((e) => {
          this.savingWard = false;
          this.$refs.toast.error('Error saving ward');
        });
    },

    // Bed Modal
    openBedModal(bed = null) {
      this.isEditingBed = !!bed;
      if (bed) {
        this.bedForm = { ...bed };
      } else {
        this.bedForm = {
          bedID: '',
          wardID: this.filterWardID || '',
          wardName: '',
          bedNumber: '',
          bedType: 'Standard',
          status: 'Available',
          notes: ''
        };
        if (this.filterWardID) {
          this.setBedWardName();
        }
      }
      const modal = new bootstrap.Modal(document.getElementById('bedModal'));
      modal.show();
    },

    setBedWardName() {
      const ward = this.wards.find(w => w.wardID === this.bedForm.wardID);
      this.bedForm.wardName = ward ? ward.wardName : '';
    },

    saveBed() {
      if (!this.canSaveBed) return;

      this.savingBed = true;
      const data = new FormData();
      data.append("function", this.isEditingBed ? "updateBed" : "addBed");
      data.append("facilityID", this.facilityID);
      data.append("facilityName", this.facilityName);
      
      if (this.isEditingBed) {
        data.append("bedID", this.bedForm.bedID);
      }
      
      data.append("wardID", this.bedForm.wardID);
      data.append("wardName", this.bedForm.wardName);
      data.append("bedNumber", this.bedForm.bedNumber);
      data.append("bedType", this.bedForm.bedType);
      data.append("status", this.bedForm.status);
      data.append("notes", this.bedForm.notes);
      data.append("sessionNames", this.sessionNames);
      data.append("sessionIdNo", this.sessionIdNo);

      execute(data, hospital)
        .then((res) => {
          this.savingBed = false;
          if (res.data.success) {
            this.$refs.toast.success(this.isEditingBed ? 'Bed updated successfully' : 'Bed added successfully');
            bootstrap.Modal.getInstance(document.getElementById('bedModal')).hide();
            this.loadBeds();
            this.loadWards();
          } else {
            this.$refs.toast.error(res.data.message || 'Failed to save bed');
          }
        })
        .catch((e) => {
          this.savingBed = false;
          this.$refs.toast.error('Error saving bed');
        });
    },

    viewPatient(bed) {
      // Navigate to patient care or admission view
      this.$refs.toast.info('Patient: ' + bed.currentPatientName);
    }
  },
  mounted() {
    this.facilityID = sessionStorage.getItem("hospitalFacilityID") || '';
    this.facilityName = sessionStorage.getItem("hospitalFacilityName") || '';
    this.sessionNames = sessionStorage.getItem("sessionNames") || '';
    this.sessionIdNo = sessionStorage.getItem("sessionIdNo") || '';

    this.loadWards();
    this.loadBeds();
  }
};
</script>

<style scoped>
.bg-pink { background-color: #e83e8c; color: #fff; }

.btn-soft-info {
  background-color: rgba(80, 165, 241, 0.1);
  color: #50a5f1;
  border: none;
}
.btn-soft-info:hover { background-color: rgba(80, 165, 241, 0.2); }

.btn-soft-warning {
  background-color: rgba(241, 180, 76, 0.1);
  color: #f1b44c;
  border: none;
}
.btn-soft-warning:hover { background-color: rgba(241, 180, 76, 0.2); }

.btn-soft-danger {
  background-color: rgba(244, 106, 106, 0.1);
  color: #f46a6a;
  border: none;
}
.btn-soft-danger:hover { background-color: rgba(244, 106, 106, 0.2); }

.nav-tabs-custom .nav-link {
  border: none;
  color: #74788d;
}
.nav-tabs-custom .nav-link.active {
  color: #556ee6;
  border-bottom: 2px solid #556ee6;
}
</style>
